import type { ApolloCache } from "@apollo/client/cache"
import cloneDeep from "lodash-es/cloneDeep"

import {
  FloorTypename,
  ProjectChild,
  ProjectParentTypename,
  ProjectTypename,
  RoomTypename
} from "shared/types/Project"

import {
  FloorChildrenFragment,
  FloorChildrenFragmentDoc
} from "entities/floors/graphql/fragments.generated"
import {
  ProjectChildrenFragment,
  ProjectChildrenFragmentDoc
} from "entities/projects/graphql/fragments.generated"
import {
  RoomChildrenFragment,
  RoomChildrenFragmentDoc
} from "entities/rooms/graphql/fragments.generated"

export function getProjectChildren(
  parentID: string,
  parentType: ProjectParentTypename,
  cache: ApolloCache<object>
): ProjectChild[] | null | undefined {
  if (parentType === RoomTypename) {
    const cacheId = cache.identify({ id: parentID, __typename: RoomTypename })
    if (!cacheId) return null
    return cloneDeep(
      cache.readFragment<RoomChildrenFragment>({
        optimistic: true,
        id: cacheId,
        fragment: RoomChildrenFragmentDoc,
        fragmentName: "RoomChildren"
      })?.children
    )
  }
  if (parentType === FloorTypename) {
    const cacheId = cache.identify({ id: parentID, __typename: FloorTypename })
    if (!cacheId) return null
    return cloneDeep(
      cache.readFragment<FloorChildrenFragment>({
        optimistic: true,
        id: cacheId,
        fragment: FloorChildrenFragmentDoc,
        fragmentName: "FloorChildren"
      })?.children
    )
  }

  const cacheId = cache.identify({ id: parentID, __typename: ProjectTypename })
  if (!cacheId) return null
  return cloneDeep(
    cache.readFragment<ProjectChildrenFragment>({
      optimistic: true,
      fragment: ProjectChildrenFragmentDoc,
      fragmentName: "ProjectChildren",
      id: cacheId
    })?.children
  )
}
